/**
 * Context insight chip display constants, shared by every surface that
 * renders place_context_stats chips (PlaceDetail sidebar — Option A; feed
 * card chip — Option B) so a "rainy_day" pattern always gets the same icon.
 * Chip copy itself lives server-side in placeContextInsightsService for the
 * same reason.
 */
export const CONTEXT_CHIP_ICONS = {
  rainy_day: 'rain',
  snow_day: 'snowflake',
  sunny_day: 'sun',
  weekend: 'calendarDays',
  weekday: 'calendarDays',
  season: 'sparkles'
};
